/* eslint-disable new-cap */
import LazyLoad from '../../common/LazyLoading/LazyLoading';
import { RoutesConfig } from '../../../config/router/router';
import { routes } from '../../../config/routes/routes';
import React from 'react';

const Dashboard = LazyLoad(
  () => import('../../pages/admin/DashboardPage/DashboardPage'),
);
const UsersPage = LazyLoad(
  () => import('../../pages/admin/User/UsersPage/UsersPage'),
);
const UserCreatePage = LazyLoad(
  () => import('../../pages/admin/User/UserCreatePage/UserCreatePage'),
);
const UserEditPage = LazyLoad(
  () => import('../../pages/admin/User/UserEditPage/UserEditPage'),
);
const TranslationsPage = LazyLoad(
  () =>
    import('../../pages/admin/Translation/TranslationsPage/TranslationsPage'),
);
const ProfilePage = LazyLoad(
  () => import('../../pages/admin/Profile/ProfilePage/ProfilePage'),
);
const SettingsPage = LazyLoad(
  () => import('../../pages/admin/Settings/SettingsPage/SettingsPage'),
);

const LoginPage = LazyLoad(
  () => import('../../pages/public/LoginPage/LoginPage'),
);
const PasswordResetPage = LazyLoad(
  () => import('../../pages/public/PasswordResetPage/PasswordResetPage'),
);
const PasswordResetConfirmationPage = LazyLoad(
  () =>
    import(
      '../../pages/public/PasswordResetConfirmationPage/PasswordResetConfirmationPage'
    ),
);
const RegistrationConfirmationPage = LazyLoad(
  () =>
    import(
      '../../pages/public/RegistrationConfirmationPage/RegistrationConfirmationPage'
    ),
);
const DeletionConfirmationPage = LazyLoad(
  () =>
    import(
      '../../pages/public/DeletionConfirmationPage/DeletionConfirmationPage'
    ),
);
const IdentityChangeConfirmationPage = LazyLoad(
  () =>
    import(
      '../../../core/pages/public/IdentityChangeConfirmationPage/IdentityChangeConfirmationPage'
    ),
);

const CompaniesPage = LazyLoad(
  () => import('../../pages/admin/Company/CompaniesPage/CompaniesPage'),
);
const CompanyCreatePage = LazyLoad(
  () => import('../../pages/admin/Company/CompanyCreatePage/CompanyCreatePage'),
);
const CompanyEditPage = LazyLoad(
  () => import('../../pages/admin/Company/CompanyEditPage/CompanyEditPage'),
);
const CompanyPage = LazyLoad(
  () => import('../../pages/admin/Company/CompanyPage/CompanyPage'),
);

export const CORE_ROUTER_CONFIG: RoutesConfig = {
  auth: [
    {
      path: routes.auth.registrationConfirmation,
      element: <RegistrationConfirmationPage />,
    },
    {
      path: routes.auth.deletionConfirmation,
      element: <DeletionConfirmationPage />,
    },
    {
      path: routes.auth.identityChangeConfirmation,
      element: <IdentityChangeConfirmationPage />,
    },
  ],
  authNonAuth: [
    {
      path: routes.auth.registrationConfirmation,
      element: <RegistrationConfirmationPage />,
    },
    {
      path: routes.auth.deletionConfirmation,
      element: <DeletionConfirmationPage />,
    },
    {
      path: routes.auth.identityChangeConfirmation,
      element: <IdentityChangeConfirmationPage />,
    },
    { path: routes.auth.passwordReset, element: <PasswordResetPage /> },
    {
      path: routes.auth.passwordResetConfirmation,
      element: <PasswordResetConfirmationPage />,
    },
    { path: routes.auth.login, element: <LoginPage /> },
    { path: routes.homepage, element: <LoginPage /> },
    { path: '*', navigate: routes.auth.login },
  ],
  admin: [
    {
      path: routes.admin.dashboard,
      element: <Dashboard />,
    },
    {
      path: routes.homepage,
      element: <Dashboard />,
    },
    {
      path: routes.admin.users.list,
      element: <UsersPage />,
    },
    {
      path: routes.admin.users.new,
      element: <UserCreatePage />,
    },
    {
      path: routes.admin.users.edit,
      element: <UserEditPage />,
    },
    {
      path: routes.admin.profile,
      element: <ProfilePage />,
    },
    {
      path: routes.admin.settings,
      element: <SettingsPage />,
    },
    {
      path: routes.admin.translations.list,
      element: <TranslationsPage />,
    },
    {
      path: routes.admin.companies.list,
      element: <CompaniesPage />,
    },
    {
      path: routes.admin.companies.new,
      element: <CompanyCreatePage />,
    },
    {
      path: routes.admin.companies.edit,
      element: <CompanyEditPage />,
    },
    {
      path: routes.admin.company,
      element: <CompanyPage />,
    },
  ],
  adminNonAuth: [],
};
